import { OnlineOfflineStatusType } from '../online-offline/online-offline.model';

export type SockServerEvent = SubMessageEvent | SockMessageServerEvent;

export type SockMessageServerEvent =
ProjectMessageEvent
  | FailingProjectMessageEvent
  | ContestMessageEvent
  | OnlineOfflineMessageEvent
  // |  OtherMessageEvent
  ;

export interface SubMessageEvent {
  channel: 'subscribe',
  body: 'OK'
}

export interface BaseMessageEvent<Type, Data, ParentType = 'notifications'> {
  channel: 'user',
  body: {
    aggregated: null,
    data: Data,
    display: boolean,
    id: string,
    is_important: boolean,
    is_notification: boolean,
    is_project: boolean,
    message: string,
    news_feed: boolean,
    no_persist: boolean,
    parent_type: ParentType,
    popup: boolean,
    targets: any[],
    timestamp: number,
    type: Type
  }
}

export interface WebsocketProjectData {
  actionText: '',
  appended_descr: string,
  currency: string,
  currencyCode: string,
  exchangerate: string,
  featured: boolean,
  free_bid_until: number,
  fulltime: boolean,
  hideBids: boolean,
  id: number,
  imgUrl: string,
  isLocal: boolean,
  isMinimallyPostedProject: boolean,
  isTest: boolean,
  jobString: string,
  jobs: number[],
  linkUrl: string,
  maxbudget: number,
  minbudget: number,
  minimallyPostedProjectBudgetSet: boolean,
  nonpublic: boolean,
  projIsHourly: boolean,
  publicName: string,
  showBudgetMinimallyPostedProject: true,
  submitDate: string,
  text: string,
  time: number,
  title: string,
  userId: number,
  userName: string,
}

interface ContestData {
  actionText: string,
  appended_descr: string,
  buyer: string,
  buyerUrl: string,
  currency: string,
  currencyCode: string,
  exchangerate: string,
  extended: boolean,
  featured: boolean,
  highlight: undefined,
  id: string,
  imgUrl: string,
  isTest: boolean,
  jobString: string,
  jobs: number[],
  linkUrl: string,
  locked: boolean,
  maxbudget: string,
  private: boolean,
  sealed: boolean,
  submitDate: string,
  time: number,
  title: string,
  userId: string,
  userName: string
}

export type ProjectMessageEvent = BaseMessageEvent<'project', WebsocketProjectData>;
export type FailingProjectMessageEvent = BaseMessageEvent<'failingProject', WebsocketProjectData>;
export type ContestMessageEvent = BaseMessageEvent<'contest', ContestData>;
export type OtherMessageEvent = BaseMessageEvent<string, any>;
export type OnlineOfflineMessageEvent = BaseMessageEvent<
  'statusget',
  { [userId: string]: OnlineOfflineStatusType },
  'onlineoffline'
  >

export function isOnlineOfflineMessageEvent(event: SockServerEvent): event is OnlineOfflineMessageEvent {
  return (
    event.channel === 'user' &&
    event.body &&
    event.body.parent_type === 'onlineoffline'
  );
}

export function isSockMessageServerEvent(event: SockServerEvent): event is SockMessageServerEvent {
  return (event.channel === 'user');
}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/websocket/server-message-event.model.ts